// Handles social sharing buttons on the blog details page
document.addEventListener("DOMContentLoaded", () => {
  function openFixedPopup(url, title) {
    const features =
      "height=400, width=550, location=no, toolbar=no, status=no, " +
      "directories=no, menubar=no, scrollbars=yes, resizable=no, " +
      "centerscreen=yes, chrome=yes, left=685, top=316";

    return window.open(url, title, features);
  }

  function copyLink(button) {
    if (window.innerWidth < 1024) {
      // Mobile / Tablet
      if (navigator.share) {
        navigator
          .share({
            title: document.title,
            text: "Check this out!",
            url: window.location.href,
          })
          .catch((err) => console.warn("Share failed:", err));
      } else {
        // Fallback to clipboard
        doClipboardCopy(button);
      }
    } else {
      // Desktop
      doClipboardCopy(button);
    }
  }

  function doClipboardCopy(button) {
    const url = window.location.href;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => showCopyTooltip(button))
        .catch((err) => console.warn("Clipboard copy failed:", err));
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = url;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        showCopyTooltip(button);
      } catch (err) {
        console.warn("Fallback copy failed:", err);
      }
      document.body.removeChild(textarea);
    }
  }

  document.querySelectorAll(".blog-social-btn").forEach((button) => {
    button.addEventListener("click", () => {
      const type = button.getAttribute("data-type");
      const pageUrl = encodeURIComponent(window.location.href);

      switch (type) {
        case "facebook":
          openFixedPopup(
            `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`,
            "Share on Facebook"
          );
          break;

        case "twitter":
          openFixedPopup(
            `https://twitter.com/intent/tweet?url=${pageUrl}`,
            "Share on Twitter"
          );
          break;

        case "email":
          window.location.href = `mailto:?body=${pageUrl}`;
          break;

        case "copy":
          copyLink(button)
          break;
      }
    });
  });
});

function showCopyTooltip(button) {
  let tooltip = document.createElement("span");
  tooltip.className = "custom-copy-tooltip";
  tooltip.textContent = "Link copied!";
  document.body.appendChild(tooltip);

  const rect = button.getBoundingClientRect();
  tooltip.style.left = `${rect.left + rect.width / 2 + 15}px`;
  tooltip.style.top = `${rect.top - 52}px`;
  tooltip.style.transform = "translateX(-50%)";

  requestAnimationFrame(() => tooltip.classList.add("show"));

  setTimeout(() => {
    tooltip.classList.remove("show");
    setTimeout(() => tooltip.remove(), 200);
  }, 1000);
}
